// src/components/Footer.jsx
import React from 'react';



const Footer = () => {
  return (
    <div className="footer">
      <p>© 2024 TSS Printing. All rights reserved.</p>
    </div>
  );
};

export default Footer;
